import React from 'react';
import styles from './ControlComponent.module.scss';
import cn from 'classnames';
import { Button, Icon } from 'antd';
import { getSelectedOptionContent } from '../../lib/getSelectedOptionContent';
import { ReactComponent as ukDropdown } from '../../../../../resource/ukDropdown.svg';

const ControlComponent = ({
  visible,
  loading,
  disabled,
  className,
  options = [],
  value,
  placeholder,
  ...props
}) => {
  const placeholderText = placeholder || 'Выбрать УК';

  const content = getSelectedOptionContent(options, value);

  const disabledBtn = disabled || loading;

  return (
    <Button
      className={cn(styles.customBtn, className)}
      disabled={disabledBtn}
      {...props}
    >
      <div className={styles.root}>
        <div className={styles.leftContent}>
          <Icon
            style={{ fontSize: '20px', color: 'transparent' }}
            component={ukDropdown}
          />
          <span
            className={content ? styles.amount : styles.placeholder}
            style={
              typeof content === 'string'
                ? {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }
                : {}
            }
          >
            {content ?? placeholderText}
          </span>
        </div>

        <Icon
          type={loading ? 'loading' : 'down'}
          className={cn(styles.icon, { [styles.visible]: visible })}
        />
      </div>
    </Button>
  );
};

export default ControlComponent;
